export const optionWrapper = {
    width: '230px',
    height: '240px',
    overflow: 'hidden',
    background: '#ffffff',
    display: 'grid',
    gap: 3,
    mr: 5,
    mb: '20px',
}

export const option = {
    border: '2px dashed #627480',
    borderRadius: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'start',
    paddingLeft: 3,
    cursor: 'pointer',
}

export const icon = {
    marginRight: '8px',
}

export const text = {
    display: 'flex',
    alignItems: 'center',
    fontWeight: '600',
    fontSize: '18px',
    lineHeight: '22px',
}
